import React from "react";
import "./projectComponent.css";
import OptimizedSlideshow from './OptimizedSlideshow';

import EduflexVideo from "./EduFlex_images/LinkedIn Video.mp4";

const EduFlex = () => {
    const mediaItems = [
        { type: 'video', src: EduflexVideo },
        { type: 'image', src: require("./EduFlex_images/1.png") },
        { type: 'image', src: require("./EduFlex_images/2.png") },
        { type: 'image', src: require("./EduFlex_images/3.png") },
        { type: 'image', src: require("./EduFlex_images/4.png") }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">EduFlex</h2>
        <span className="section__subtitle">Educational Platform</span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
            <div className="text__container">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>EduFlex is an AI-powered educational platform that revolutionizes online learning through advanced artificial intelligence, machine learning, and multimodal technologies.</p>
                <br />
                <p className='redRadio__text'><strong>AI-Powered Features:</strong></p>
                <br />
                <p className='redRadio__text'>🤖 <strong>AI Agents for PPT Generation:</strong> Intelligent agents that automatically generate comprehensive presentation slides from educational content using LLMs and RAG technology.</p>
                <br />
                <p className='redRadio__text'>📅 <strong>Smart Revision Scheduler:</strong> AI-driven exam scheduling system that optimizes study plans based on individual learning patterns and performance analytics.</p>
                <br />
                <p className='redRadio__text'>🔍 <strong>OCR & Multimodality:</strong> Advanced optical character recognition for document processing and multimodal AI that handles text, images, and video content seamlessly.</p>
                <br />
                <p className='redRadio__text'>🧠 <strong>Fine-tuned LLMs & RAG:</strong> Custom fine-tuned language models with Retrieval-Augmented Generation for personalized educational content and intelligent tutoring.</p>
                <br />
                <p className='redRadio__text'>This platform leverages cutting-edge AI technologies to provide personalized, adaptive learning experiences that enhance educational outcomes through intelligent automation and content generation.</p>
            </div>

            <div className="skills__container1 container grid">
        <div className="skills__content">
        <h3 className="skills__title">Technologies Used</h3>

        <div className="skills__box">

        <div className="skills__group">

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Python</h3>
                <span className="skills__level"></span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">LLMs</h3>
                <span className="skills__level"></span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">RAG</h3>
                <span className="skills__level"></span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Finetuning</h3>
                <span className="skills__level"></span>
            </div>
            </div>
        </div>

        <div className="skills__group">
            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">LangGraph</h3>
                <span className="skills__level"></span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">Vlms</h3>
                <span className="skills__level"></span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">n8n</h3>
                <span className="skills__level"></span>
              </div>
            </div>
          
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">LangChain</h3>
              <span className="skills__level"></span>
            </div>
          </div>
        </div>

        </div>
    </div>
            </div>
        </div>
    </section>
    );
};

export default EduFlex;